import PropTypes, {bool} from "prop-types";

const Card = (props: { title?: string; heading?: string ; description?: string, isHeading?: boolean }) => {
    return (
        <>
            <div className={'card-item'}>
                {props.isHeading === true && <h3 className={"text-gradient"}>{props.title}</h3>}
                <h4>{props.heading}</h4>
                <p>{props.description}</p>
            </div>
        </>
    )
}
Card.defaultProps = {
    title: "20%",
    heading: "Faster Time To Resolution",
    description: "Enhanced clarity and real-time log monitoring accelerate bug detection and resolution.",
    isHeading: true
}
Card.propTypes = {
    title: PropTypes.string,
    heading: PropTypes.string,
    description: PropTypes.string,
    isHeading: PropTypes.bool
}
export default Card;